import { Reveal } from "@/components/Reveal";
import { imgSrc } from "@/lib/api";

export default function VillaManifesto({ villa }) {
  if (!villa) return null;
  return (
    <section id="villa" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-20 sm:px-8 lg:px-16 lg:py-32" data-testid="villa-section">
      <Reveal>
        <p className="eyebrow mb-4">{villa.eyebrow || "The Villa"}</p>
        <h2 className="max-w-3xl font-serif text-2xl leading-snug tracking-tight text-cream sm:text-3xl lg:text-4xl">
          {villa.heading}
        </h2>
      </Reveal>
      <div className="mt-16 space-y-20 lg:space-y-28">
        {(villa.chapters || []).map((ch, i) => (
          <div key={ch.num || i} className={`grid items-center gap-8 lg:grid-cols-12 lg:gap-14 ${i % 2 ? "" : ""}`}>
            <Reveal className={`lg:col-span-5 ${i % 2 ? "lg:order-2" : ""}`} delay={0.1}>
              <div className="flex items-start gap-5">
                <span className="font-mono text-sm text-copper-400 pt-2" aria-hidden="true">{ch.num}</span>
                <div>
                  <h3 className="font-serif text-2xl text-cream sm:text-3xl">{ch.title}</h3>
                  <p className="mt-4 text-base font-light leading-relaxed text-cream-muted">{ch.text}</p>
                </div>
              </div>
            </Reveal>
            <Reveal className={`lg:col-span-7 ${i % 2 ? "lg:order-1" : ""}`} delay={0.2}>
              <div className="group overflow-hidden rounded-2xl border border-white/10">
                <img
                  src={imgSrc(ch.image)}
                  alt={ch.title}
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
                />
              </div>
            </Reveal>
          </div>
        ))}
      </div>
    </section>
  );
}
